import qs, { ParsedQs } from "qs";
import { useLocation, useNavigate } from "react-router-dom";

import { useGetProductDetailsCollection } from "lib/core-react/hooks/private/useProduct";
import { FacetFieldModel } from "models/productDetailCollectionModel";

import AppList from "components/App/AppList";
import {
  StyledProductSidebarItem,
  StyledProductSidebarItemTitle,
} from "../index.styled";
import MultiCheckedCell from "../MultiCheckedCell";

interface IProps {
  sellersField: FacetFieldModel[];
}

const SellersFacet = ({ sellersField }: IProps) => {
  const location = useLocation();
  const parsedQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const navigate = useNavigate();
  const { sellers, ...rest } = parsedQuery;
  const { getProductDetailsCollection } = useGetProductDetailsCollection();

  const onSelectSellers = async (name: string & ParsedQs) => {
    let updatedSellers;

    if (Array.isArray(sellers)) {
      if (sellers.includes(name)) {
        // Remove the seller if it already exists
        // @ts-ignore FIXME
        // updatedSellers = sellers.filter((seller) => seller !== name);
      } else {
        // Add the seller if it doesn't exist
        updatedSellers = [...sellers, name];
      }
    } else {
      // If seller array does not exist, create it with the current sellerName
      updatedSellers = [name];
    }

    const queryString = qs.stringify({
      ...rest,
      sellers: updatedSellers,
    });
    await getProductDetailsCollection(
      {
        region: "BD",
        locale: "en",
      },
      { sellers: updatedSellers, ...rest }
    );
    navigate(`/product-manage/products?${queryString}`);
  };

  return (
    <StyledProductSidebarItem>
      <StyledProductSidebarItemTitle>Sellers</StyledProductSidebarItemTitle>
      <AppList
        data={sellersField}
        renderItem={(data) => (
          <MultiCheckedCell
            key={data.getName()}
            data={data}
            onChange={onSelectSellers}
            selected={Array.isArray(sellers) ? sellers : []}
          />
        )}
      />
    </StyledProductSidebarItem>
  );
};
export default SellersFacet;
